module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-6078d0a7!./packages/dof-input/colmo.css
// module id = 500
// module chunks = 0 1